import React from "react";
import Typed from "typed.js";
const Type = (option,typespeed,backspeed) => {
    const options = {
        strings: option,
            loop:true,
            typeSpeed:typespeed,
            backSpeed:backspeed,
            showCursor:false,
            backDelay: 2000,
            startDelay: 1500,
            
    }
    const typed = new Typed ('.typing-element', options);
    return ()=>{
        typed.destroy();
    }
    
}
 
export default Type;